import BaseResource from './index'

export default class LocationResource extends BaseResource {
    static endpoint = '/locations'

    static async nearest() {
        const response = await this.wrap('/nearest').get()

        if (response.status == 200) {
            return new LocationResource(response.data)
        }

        return null
    }

    toString() {
        return this.attributes.name
    }
}
